var _dec, _class, _descriptor, _dec2, _dec3, _dec4, _dec5, _dec6, _class2, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import SearchProviderTraits from "./SearchProviderTraits";
let LocationSearchProviderTraits = (_dec2 = primitiveTrait({
  type: "string",
  name: "URL",
  description: "The URL of search provider."
}), _dec3 = primitiveTrait({
  type: "number",
  name: "recommendedListLength",
  description: "Maximum amount of entries in the suggestion list."
}), _dec4 = primitiveTrait({
  type: "number",
  name: "URL",
  description: "Time to move to the result location.",
  isNullable: true
}), _dec5 = primitiveTrait({
  type: "boolean",
  name: "Is open",
  description: "True if the search results of this search provider are visible; otherwise, false.",
  isNullable: true
}), _dec6 = primitiveArrayTrait({
  type: "string",
  name: "Attribution",
  description: "The attribution text for this search provider.",
  isNullable: true
}), _class2 = class LocationSearchProviderTraits extends mixTraits(SearchProviderTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "url", _descriptor2, this);
    _initializerDefineProperty(this, "recommendedListLength", _descriptor3, this);
    _initializerDefineProperty(this, "flightDurationSeconds", _descriptor4, this);
    _initializerDefineProperty(this, "isOpen", _descriptor5, this);
    _initializerDefineProperty(this, "attributions", _descriptor6, this);
  }
}, _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "url", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "recommendedListLength", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 5;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "flightDurationSeconds", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1.5;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isOpen", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "attributions", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class2);
export { LocationSearchProviderTraits as default };
export let SearchProviderMapCenterTraits = (_dec = primitiveTrait({
  type: "boolean",
  name: "Map center",
  description: "Whether the current location of the map center is supplied with search request"
}), _class = class SearchProviderMapCenterTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "mapCenter", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "mapCenter", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class);